module.exports = __webpack_public_path__ + "img/featured-the-straits-times.f408bea0.png";